export default "__VITE_ASSET__BEKffvph__"